<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="10" md="12" lg="10" xl="8">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FhContainer'
}
</script>

<style scoped>

</style>
